// extracted by mini-css-extract-plugin
export default {"tabs_container":"TabsNew_tabs_container__GQ+X0","tab":"TabsNew_tab__gXe2c"};